module.exports = __webpack_public_path__ + "img/abilities.62c091cc.svg";